<template>
	<div role="tabcard" class="tab-pane" id="add-customer">
		<div class="card card-default">
		    <div class="card-header">
				<div class="fw-600 float-left font-size-large">
		    		Add customer <span v-if="project">to<strong> {{ project.name }}</strong></span>
				</div>
		    </div>

		    <div class="card-body">
		        <!-- Success Message -->
		        <div class="alert alert-success" v-if="form.successful">
		        	<span v-if="inviteStatus == 'new'">
		            	Great, an invitation was sent to <strong>{{ emailSent }}</strong>!
		        	</span>
		        	<span v-else>
		        		Success!
		        	</span>
		        </div>

		        <div class="alert alert-danger" v-if="error">
		            {{ errorMessage }}
		        </div>

		        <div class="row">
		        	<div class="col-md-10 offset-md-1">
		        		Invite a customer to the project so they can receive updates and approve change orders and material selections.
		        	<hr />
		        	</div>
		        </div>

		        <form role="form">

		        	<!-- Name -->
		        	<div class="form-group row">
		                <label class="col-md-4 col-form-label text-md-right">Customer name</label>

		                <div class="col-md-6">
		                    <input type="text" class="form-control" name="name" v-model="form.name" :class="{'is-invalid': form.errors.has('name')}">
		                    <span class="invalid-feedback" v-show="form.errors.has('name')">
		                        {{ form.errors.get('name') }}
		                    </span>
		                </div>
		            </div>

		            <!-- E-Mail Address -->
		            <div class="form-group row">
		                <label class="col-md-4 col-form-label text-md-right">Customer email</label>

		                <div class="col-md-6">
		                    <input type="email" class="form-control" name="email" v-model="form.email" :class="{'is-invalid': form.errors.has('email')}">
		                    <span class="invalid-feedback" v-show="form.errors.has('email')">
		                        {{ form.errors.get('email') }}
		                    </span>
		                </div>
		            </div>

		            <!-- Send Invitation Button -->
		            <div class="form-group row mb-0">
		                <div class="offset-md-4 col-md-6">
		                    <button type="submit" class="btn btn-primary"
		                            @click.prevent="sendInvitation"
		                            :disabled="form.busy">


		                        <!-- 
		                        :key here is workaround for removing fontawesome icons with v-if 
		                        https://github.com/FortAwesome/vue-fontawesome/issues/30
		                    	-->
		                        <span :key='123' v-if="form.busy">
		                            <i class="fa fa-btn fa-spinner fa-spin"></i> Sending
		                        </span>

		                        <span v-else>
		                            Send invitation
		                        </span>
		                    </button>
		                </div>
		            </div>
		        </form>
		    </div>
		</div>
	</div>
</template>

<script>
    export default {
    	props: ['role', 'project'],

        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            	form: new SparkForm({
            	    email: '',
            	    name: '',
            	}),
            	error: false,
            	errorMessage: '',
            	successMessage: '',
            	emailSent: '',
            	projectId: '',
            	inviteStatus: ''
            };
        },

        computed: {
            
        },

        methods: {
           sendInvitation: function() {
           		this.form.projectId = this.project.id;
           		Spark.post('/api/customer', this.form)
           		    .then(response => {
           		    	this.error = false;
           		    	this.loading = false;
           		        this.form.email = '';
           		        this.successMessage = response.message;
           		        this.emailSent = response.email;
           		        this.inviteStatus = response.status;

           		        // If the user was existing, let's refresh the view
           		        if (this.inviteStatus == 'existing') {
           		        	Bus.$emit('refresh-current-project');
           		        }
           		    })
           		    .catch(error => {
           		    	this.loading = false;
           		    	console.log(error);
           		    	if (!this.form.errors) {
           		    		this.error = true;
           		    		errorMessage = error.message;
           		    	}
           		    });
           },
        }
    }
</script>